// src/pages/landing/components/About.js
import React from 'react';
import './About.css';
import ubcCampusAerial   from '../../../assets/images/ubc-campus-aerial.jpg';
import koernerLibrary    from '../../../assets/images/ubc-koerner-library.jpg';
import ubcCampusBuilding from '../../../assets/images/ubc-campus-building.jpg';
import ubcStudentsCollab from '../../../assets/images/ubc-students-collab.jpg';
import ravenSculpture    from '../../../assets/images/ubc-raven-sculpture.jpg';

const About = () => {
  const aboutSections = [
    {
      id: 'about-us',
      title: 'About Us',
      content: 'MOOD2MOVE is a revolutionary student wellness platform designed to bridge the critical gap between mental health awareness and accessible physical movement solutions within university communities.',
      reverse: false,
      image: {
        src: ubcCampusAerial,
        alt: 'UBC campus aerial view',
        credit: 'Photo by Luca Bravo on Unsplash'
      }
    },
    {
      id: 'our-mission',
      title: 'Our Mission',
      content: 'Our mission is to transform how students approach wellness by creating an innovative digital ecosystem that connects emotional well-being with personalized movement experiences. MOOD2MOVE addresses the pressing campus-wide challenge of student mental health and sedentary lifestyles by providing a highly accessible, technology-driven solution that empowers students to take immediate, actionable steps toward better physical and emotional wellness.',
      reverse: true,
      image: {
        src: koernerLibrary,
        alt: 'Koerner Library plaza, UBC Vancouver campus',
        credit: 'Photo: Koerner Library UBC, Wikimedia Commons, CC BY-SA 4.0'
      }
    },
    {
      id: 'innovation-impact',
      title: 'Innovation & Impact',
      content: 'MOOD2MOVE represents a groundbreaking approach to campus wellness that hasn\'t been implemented at UBC before – combining mood-tracking technology with evidence-based movement therapy to create personalized wellness journeys for students. Our platform solves the identified gap between recognizing mental health struggles and having immediate, practical resources available 24/7.',
      reverse: false,
      image: {
        src: ubcCampusBuilding,
        alt: 'UBC campus building and landscape',
        credit: 'Photo by Nathan Dumlao on Unsplash'
      }
    },
    {
      id: 'student-centered',
      title: 'Student-Centered Design',
      content: 'Built entirely by students, for students, MOOD2MOVE ensures meaningful student involvement in every aspect of development, from user interface design and content creation to peer support features and community engagement initiatives. Our platform is designed to benefit thousands of UBC students by providing visible, transparent, and accessible wellness resources that promote broad community engagement across all faculties and demographics.',
      reverse: true,
      image: {
        src: ubcStudentsCollab,
        alt: 'Students collaborating on campus',
        credit: 'Photo by Marvin Meyer on Unsplash'
      }
    },
    {
      id: 'campus-transformation',
      title: 'Vision for Campus Transformation',
      content: 'We envision a campus where wellness is integrated seamlessly into daily student life, where technology serves as a bridge to better mental and physical health, and where every student has the tools and community support needed to thrive academically and personally.',
      reverse: false,
      image: {
        src: ravenSculpture,
        alt: 'Raven and the First Men sculpture, UBC Museum of Anthropology',
        credit: 'Photo: Raven and the First Men, Bill Reid. Wikimedia Commons, CC BY-SA 2.5'
      }
    }
  ];

  return (
    <section className="about-section" id="about">
      <div className="about-container">
        <div className="about-header">
          <h2 className="about-main-title">About MOOD2MOVE</h2>
          <p className="about-main-subtitle">
            Revolutionizing student wellness through innovative technology and personalized movement solutions
          </p>
        </div>

        <div className="about-content">
          {aboutSections.map((section) => (
            <div
              key={section.id}
              className={`about-card ${section.reverse ? 'about-card-reverse' : ''}`}
            >
              <div className="about-card-content">
                <div className="about-text-content">
                  <h3 className="about-card-title">{section.title}</h3>
                  <p className="about-card-description">{section.content}</p>
                </div>
                <div className="about-image-content">
                  <figure className="about-image-wrapper">
                    <img
                      src={section.image.src}
                      alt={section.image.alt}
                      className="about-card-image"
                      loading="lazy"
                    />
                    <figcaption className="about-image-credit">
                      {section.image.credit}
                    </figcaption>
                  </figure>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default About;